module.exports = __webpack_public_path__ + "static/media/simple-icon.345871b4.svg";